'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/arrow.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _reactRouterDom = require('react-router-dom');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _themes = require('@marmalade/themes');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var _componentThemes$prog = _themes.componentThemes.progressBar,
  arrowVariants = _componentThemes$prog.arrowVariants,
  arrowStyle = _componentThemes$prog.arrowStyle,
  arrowTheme = _componentThemes$prog.arrowTheme;
var arrowStyles = function arrowStyles(props) {
  var first = props.first,
    last = props.last,
    active = props.active,
    complete = props.complete;
  var theme = arrowTheme(props.theme);
  var height = 47;
  var chooseColor = function chooseColor(style) {
    if (active) {
      return style + '_' + arrowVariants.active;
    }
    if (complete) {
      return style + '_' + arrowVariants.complete;
    }
    return style;
  };
  var point = {
    ':after': {
      content: '""',
      position: 'absolute',
      zIndex: 3,
      right: '-35px',
      top: 0,
      border: height / 2 + 'px solid transparent',
      borderLeftColor: theme[chooseColor(arrowStyle('backgroundColor'))],
      borderLeftWidth: '15px'
    }
  };
  var tail = {
    ':before': {
      content: '""',
      position: 'absolute',
      zIndex: 2,
      left: 0,
      top: 0,
      border: height / 2 + 'px solid transparent',
      borderTopColor: theme[chooseColor(arrowStyle('backgroundColor'))],
      borderBottomColor: theme[chooseColor(arrowStyle('backgroundColor'))],
      borderLeftColor: theme.Page_backgroundColor,
      borderLeftWidth: '15px',
      borderRightWidth: 0
    }
  };
  return Object.assign({
    backgroundColor: theme[chooseColor(arrowStyle('backgroundColor'))],
    color: theme[chooseColor(arrowStyle('color'))],
    textDecoration: props.active || props.complete ? theme[arrowStyle('textDecoration')] || 'none' : 'none',
    display: 'block',
    paddingLeft: !first ? '12.5px' : undefined,
    minHeight: height + 'px',
    lineHeight: height + 'px',
    fontWeight: theme.fontBold,
    transition: 'none',
    borderTopRightRadius: last ? '3px' : undefined,
    borderTopLeftRadius: first ? '3px' : undefined,
    borderBottomRightRadius: last ? '3px' : undefined,
    borderBottomLeftRadius: first ? '3px' : undefined
  }, !last ? point : {}, !first ? tail : {}, {
    ':hover': {
      color: theme[chooseColor(arrowStyle('color'))],
      textDecoration: props.active || props.complete ? theme[arrowStyle('textDecoration', 'hover')] || 'none' : 'none'
    }
  });
};
var filterProps = ['active', 'complete', 'first', 'last'];
var ArrowLink = (0, _glamorous2.default)(_reactRouterDom.Link, {
  filterProps: filterProps
})(arrowStyles);
var ArrowSpan = (0, _glamorous2.default)('span')(arrowStyles);
Arrow.propTypes = {
  to: _propTypes.string.isRequired,
  active: _propTypes.bool.isRequired,
  complete: _propTypes.bool.isRequired,
  children: _propTypes.node.isRequired,
  first: _propTypes.bool.isRequired,
  last: _propTypes.bool.isRequired
};
function Arrow(props) {
  var children = props.children,
    to = props.to,
    rest = _objectWithoutProperties(props, ['children', 'to']);
  var Element = props.active || props.complete ? ArrowLink : ArrowSpan;
  return _react2.default.createElement(Element, Object.assign({
    to: props.active || props.complete ? to : undefined
  }, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 91
    },
    __self: this
  }), children);
}
exports.default = Arrow;